export default __webpack_public_path__ + "static/media/handi-loyalty_org.f15d6ecb.png";